export default "__VITE_ASSET__B_BtA3n0__"